import axios from "axios";

import { API } from "./api";


const consumerApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default consumerApi;
